// ============================================
// Google'da Reklam Vermek İstiyorum - Blog Content
// ============================================

import { BlogContent } from '../../types';

export const googleDaReklamVermekIstiyorumContent: BlogContent = {
  tableOfContents: [
    { id: "nereden-baslamaliyim", title: "Nereden Başlamalıyım?" },
    { id: "ilk-adimlar", title: "İlk Adımlar" },
    { id: "butce-planlama", title: "Bütçe Planlama" },
    { id: "basariya-ulasmak", title: "Başarıya Ulaşmak" },
    { id: "sik-hatalar", title: "Sık Yapılan Hatalar" },
    { id: "2025-trendleri", title: "2025-2026 Trendleri" }
  ],
  content: [
    {
      type: "paragraph",
      value: "<strong>Google'da reklam vermek istiyorum</strong> ama nereden başlayacağımı bilmiyorum diyorsanız, doğru yerdesiniz. Dijital pazarlamanın en etkili kanallarından biri olan <strong>Google Ads</strong>, doğru rehberlikle hızla öğrenilebilir ve işletmenize değer katmaya başlayabilir. Bu rehberde, hiç deneyiminiz olmasa bile başarılı <strong>Google reklamları</strong> oluşturmanız için ihtiyacınız olan her şeyi adım adım anlatacağım."
    },
    {
      type: "image",
      value: "/images/blog/google-reklam-baslangic.jpg",
      alt: "Google Ads başlangıç rehberi - yeni başlayanlar için kampanya kurulum adımları",
      caption: "Google'da reklam vermeye başlamanın ilk adımları"
    },
    { type: "heading", value: "Nereden Başlamalıyım?", id: "nereden-baslamaliyim" },
    {
      type: "paragraph",
      value: "<strong>Google'da reklam vermek</strong> istediğinizde ilk adım, hedeflerinizi net bir şekilde belirlemektir. Reklam vermeden önce kendinize şu soruları sorun:"
    },
    {
      type: "list",
      items: [
        "<strong>Ne satmak istiyorum?</strong> Ürün mü, hizmet mi yoksa marka bilinirliği mi?",
        "<strong>Hedef kitlem kim?</strong> Yaş, cinsiyet, konum, ilgi alanları?",
        "<strong>Bütçem ne kadar?</strong> Aylık ne kadar yatırım yapabilirim?",
        "<strong>Başarıyı nasıl ölçeceğim?</strong> Satış, form doldurma, telefon araması?",
        "<strong>Rakiplerim ne yapıyor?</strong> Hangi anahtar kelimelere reklam veriyorlar?"
      ]
    },
    {
      type: "paragraph",
      value: "Bu sorulara net cevaplar verdikten sonra, <strong>Google Ads stratejinizi</strong> oluşturmaya başlayabilirsiniz. Hiç deneyiminiz yoksa, küçük bir bütçeyle (günlük 100-200₺) test kampanyası başlatmanızı öneririm."
    },
    {
      type: "subheading",
      value: "Temel Gereksinimler"
    },
    {
      type: "list",
      items: [
        "<strong>Web Sitesi veya Landing Page:</strong> Müşterileri yönlendirebileceğiniz bir sayfa",
        "<strong>Google Hesabı:</strong> Gmail adresi yeterli",
        "<strong>Ödeme Yöntemi:</strong> Kredi kartı veya banka kartı",
        "<strong>İşletme Bilgileri:</strong> Firma adı, vergi numarası (fatura için)",
        "<strong>Telefon Numarası:</strong> Google doğrulama için gerekli olabilir"
      ]
    },
    { type: "heading", value: "İlk Adımlar: Hesap Açma ve Kurulum", id: "ilk-adimlar" },
    {
      type: "paragraph",
      value: "<strong>Google Ads hesabı açmak</strong> oldukça basittir. İşte adım adım süreç:"
    },
    {
      type: "subheading",
      value: "1. Google Ads Hesabı Oluşturma"
    },
    {
      type: "list",
      items: [
        "<a href=\"https://ads.google.com\" target=\"_blank\" rel=\"nofollow\">ads.google.com</a> adresine gidin",
        "\"Şimdi Başla\" butonuna tıklayın",
        "Gmail hesabınızla giriş yapın",
        "İşletme bilgilerinizi girin (ad, web sitesi, konum)",
        "Reklam hedefini seçin (satış, trafik, lead vb.)"
      ]
    },
    {
      type: "paragraph",
      value: "<strong>Önemli:</strong> Google size \"Akıllı Kampanya\" önerecektir. Daha fazla kontrol için \"Uzman Modu'na\" geçin. Sağ üstten \"Uzman Modu\" seçeneğini bulabilirsiniz."
    },
    {
      type: "subheading",
      value: "2. İlk Kampanyanızı Oluşturma"
    },
    {
      type: "paragraph",
      value: "İlk kampanyanız için <strong>Arama Ağı Kampanyası</strong> öneririm çünkü en kolay ölçülebilir ve en hızlı sonuç verir:"
    },
    {
      type: "list",
      items: [
        "<strong>Kampanya Hedefi:</strong> \"Satış\" veya \"Potansiyel Müşteriler\" seçin",
        "<strong>Kampanya Türü:</strong> \"Arama Ağı\" seçin",
        "<strong>Kampanya Adı:</strong> Açıklayıcı bir isim verin (örn: \"İstanbul Avukat - Genel\")",
        "<strong>Konum Hedefleme:</strong> Hizmet verdiğiniz şehir/bölgeleri seçin",
        "<strong>Dil:</strong> Türkçe seçin",
        "<strong>Günlük Bütçe:</strong> 100-200₺ ile başlayın"
      ]
    },
    {
      type: "subheading",
      value: "3. Anahtar Kelime Seçimi"
    },
    {
      type: "paragraph",
      value: "İlk kampanyanızda 10-15 anahtar kelime ile başlayın. <strong>Google Keyword Planner</strong> aracını kullanarak anahtar kelime fikirleri bulabilirsiniz:"
    },
    {
      type: "list",
      items: [
        "<strong>Marka Kelimeleri:</strong> Kendi marka adınız (düşük maliyet, yüksek dönüşüm)",
        "<strong>Ürün/Hizmet Kelimeleri:</strong> \"boşanma avukatı\", \"ceza avukatı\" gibi",
        "<strong>Konum+Hizmet:</strong> \"istanbul avukat\", \"kadıköy avukat\" kombinasyonları",
        "<strong>Uzun Kuyruk:</strong> \"istanbul kadıköy boşanma avukatı\" gibi spesifik kelimeler"
      ]
    },
    {
      type: "paragraph",
      value: "<strong>İpucu:</strong> İlk başta \"İfade Eşleşmesi\" kullanın (anahtar kelimeyi tırnak içine alın). Bu size orta düzey kontrol ve makul trafik sağlar."
    },
    {
      type: "subheading",
      value: "4. Reklam Metni Yazma"
    },
    {
      type: "paragraph",
      value: "Etkili bir <strong>Google Ads reklamı</strong> 3 başlık (her biri 30 karakter) ve 2 açıklama (her biri 90 karakter) içerir:"
    },
    {
      type: "list",
      items: [
        "<strong>Başlık 1:</strong> Ana anahtar kelimenizi ekleyin (\"Boşanma Avukatı\")",
        "<strong>Başlık 2:</strong> Avantajınızı belirtin (\"20 Yıl Deneyim\")",
        "<strong>Başlık 3:</strong> Harekete geçirici (\"Ücretsiz İlk Görüşme\")",
        "<strong>Açıklama 1:</strong> Hizmetinizi detaylandırın",
        "<strong>Açıklama 2:</strong> Fark yaratan özelliklerinizi ekleyin + CTA"
      ]
    },
    { type: "heading", value: "Bütçe Planlama: Ne Kadar Harcamalıyım?", id: "butce-planlama" },
    {
      type: "paragraph",
      value: "\"<strong>Google'da reklam vermek</strong> ne kadar tutar?\" en sık sorulan sorudur. Cevap: İşletmenize, sektörünüze ve rekabete bağlıdır. İşte gerçekçi bütçe önerileri:"
    },
    {
      type: "table",
      headers: ["İşletme Tipi", "Önerilen Aylık Bütçe", "Beklenen Sonuç"],
      rows: [
        ["Yerel İşletme (Berber, Kafe)", "5.000-10.000₺", "50-100 potansiyel müşteri"],
        ["Hizmet Sektörü (Avukat, Doktor)", "10.000-25.000₺", "30-70 nitelikli lead"],
        ["E-Ticaret (Orta)", "15.000-40.000₺", "200-500 sipariş"],
        ["B2B Hizmetleri", "20.000-50.000₺", "20-50 kaliteli lead"],
        ["Yüksek Rekabet Sektörü", "30.000₺+", "Değişken"]
      ]
    },
    {
      type: "paragraph",
      value: "<strong>Test-Öğren-Ölçeklendir Yaklaşımı:</strong> İlk ay düşük bütçe (5.000-10.000₺) ile başlayın, hangi anahtar kelimelerin çalıştığını görün, ikinci ayda başarılı kelimelerin bütçesini artırın."
    },
    {
      type: "subheading",
      value: "Bütçe Dağılımı"
    },
    {
      type: "list",
      items: [
        "<strong>%60 Arama Kampanyaları:</strong> En yüksek dönüşüm oranı",
        "<strong>%20 Remarketing:</strong> Sitenizi ziyaret edenlere tekrar ulaşın",
        "<strong>%10 Display:</strong> Marka bilinirliği için",
        "<strong>%10 Test Kampanyaları:</strong> Yeni stratejiler deneyin"
      ]
    },
    { type: "heading", value: "Başarıya Ulaşmak: İlk 90 Gün Planı", id: "basariya-ulasmak" },
    {
      type: "paragraph",
      value: "<strong>Google Ads başarısı</strong> bir gecede gelmez. Sistematik bir yaklaşım gerektirir:"
    },
    {
      type: "subheading",
      value: "İlk 30 Gün: Öğrenme Dönemi"
    },
    {
      type: "list",
      items: [
        "<strong>Günlük Kontrol:</strong> Kampanyalarınızı her gün kontrol edin",
        "<strong>Veri Toplama:</strong> Hangi anahtar kelimeler tıklama alıyor?",
        "<strong>Negatif Kelime Ekleme:</strong> Alakasız aramaları engelleyin",
        "<strong>Tracking Kurulumu:</strong> Dönüşüm izleme kodlarını ekleyin",
        "<strong>Beklenti:</strong> Henüz karlı olmayabilir, öğrenme aşaması"
      ]
    },
    {
      type: "subheading",
      value: "30-60. Günler: Optimizasyon"
    },
    {
      type: "list",
      items: [
        "<strong>Performans Analizi:</strong> Hangi kelimeler dönüşüm sağlıyor?",
        "<strong>Bütçe Kaydırma:</strong> Başarılı kelimelere daha fazla bütçe",
        "<strong>A/B Testing:</strong> Farklı reklam metinleri deneyin",
        "<strong>Teklif Ayarlamaları:</strong> Quality Score'u yükseltin, CPC'yi düşürün",
        "<strong>Beklenti:</strong> Başabaş noktasına yaklaşın"
      ]
    },
    {
      type: "subheading",
      value: "60-90. Günler: Ölçekleme"
    },
    {
      type: "list",
      items: [
        "<strong>Winning Keywords:</strong> Karlı kelimelerin bütçesini 2-3x artırın",
        "<strong>Yeni Kampanya Tipleri:</strong> Display, Video ekleyin",
        "<strong>Remarketing Başlatın:</strong> Site ziyaretçilerine tekrar ulaşın",
        "<strong>Landing Page Optimizasyonu:</strong> Dönüşüm oranını artırın",
        "<strong>Beklenti:</strong> Pozitif ROI ve istikrarlı büyüme"
      ]
    },
    { type: "heading", value: "Sık Yapılan Hatalar ve Nasıl Önlenir?", id: "sik-hatalar" },
    {
      type: "paragraph",
      value: "Yeni başlayanların yaptığı en yaygın hatalar ve çözümleri:"
    },
    {
      type: "list",
      items: [
        "<strong>Hata 1: Geniş Eşleşme Kullanımı</strong> → Çözüm: İfade veya tam eşleşme tercih edin",
        "<strong>Hata 2: Negatif Kelime Yok</strong> → Çözüm: Her hafta arama terimleri raporunu inceleyin",
        "<strong>Hata 3: Tek Reklam Grubu</strong> → Çözüm: Her ürün/hizmet için ayrı grup oluşturun",
        "<strong>Hata 4: Dönüşüm İzleme Yok</strong> → Çözüm: Mutlaka tracking kurulumu yapın",
        "<strong>Hata 5: Landing Page Alakasız</strong> → Çözüm: Reklam ve sayfa içeriği uyumlu olmalı",
        "<strong>Hata 6: Mobil Uyumsuz Sayfa</strong> → Çözüm: Trafiğin %70'i mobil, önceliklendirin",
        "<strong>Hata 7: Sabırsızlık</strong> → Çözüm: İlk 30 gün öğrenme dönemi, sonuçlar 60. günde gelir"
      ]
    },
    { type: "heading", value: "2025-2026 Google Ads Trendleri", id: "2025-trendleri" },
    {
      type: "paragraph",
      value: "Yeni başlıyorsanız, güncel trendleri bilmek avantaj sağlar:"
    },
    {
      type: "list",
      items: [
        "<strong>AI ve Otomasyon:</strong> Otomatik teklif stratejileri daha akıllı hale geldi",
        "<strong>Performance Max:</strong> Tüm kanalları tek kampanyada yöneten format",
        "<strong>First-Party Data:</strong> Kendi müşteri verilerinizi kullanın (remarketing listeleri)",
        "<strong>Video Short-Form:</strong> YouTube Shorts reklamları hızla büyüyor",
        "<strong>Privacy-First:</strong> Cookie'siz tracking çözümleri (GA4, Enhanced Conversions)",
        "<strong>Voice Search:</strong> Konuşma diliyle arama optimizasyonu"
      ]
    },
    {
      type: "paragraph",
      value: "<strong>Google'da reklam vermek istiyorum</strong> diyorsanız, bu rehber size sağlam bir başlangıç sağlamıştır. Unutmayın, başarı sabır, test etme ve sürekli öğrenme gerektirir. Küçük başlayın, veri toplayın, optimize edin ve büyütün. Eğer profesyonel destek isterseniz, deneyimli bir <a href=\"/blog/google-ads-danismani\" class=\"text-[#059669] font-bold hover:underline\">Google Ads danışmanı</a> ile çalışmak sürecizi hızlandırabilir. Daha fazla detay için <a href=\"https://support.google.com/google-ads/answer/6146252\" target=\"_blank\" rel=\"nofollow\">Google Ads Başlangıç Rehberi</a>'ni inceleyebilirsiniz."
    }
  ]
};

export default googleDaReklamVermekIstiyorumContent;
